// src/router.js
import { createRouter, createWebHistory } from 'vue-router'
import { getCurrentUser } from './firebase/auth-helpers.js'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('./components/MainPage.vue'),
        meta: {
            title: 'Home',
            requiresAuth: false
        }
    },
    {
        path: '/posts',
        name: 'posts',
        component: () => import('./components/post/PostList.vue'),
        meta: {
            title: 'Posts',
            requiresAuth: false
        }
    },
    {
        path: '/posting',
        name: 'posting',
        component: () => import('./components/post/PostingPage.vue'),
        meta: {
            title: 'New Post',
            requiresAuth: true
        }
    },
    {
        path: '/edit/:id',
        name: 'edit-post',
        component: () => import('./components/post/PostingPage.vue'),
        props: true,
        meta: {
            title: 'Edit Post',
            requiresAuth: true
        }
    },
    {
        path: '/sign-in',
        name: 'sign-in',
        component: () => import('./components/auth/SignInPage.vue'),
        meta: {
            title: 'Sign In',
            requiresAuth: false
        }
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import('./components/auth/SignUpPage.vue'),
        meta: {
            title: 'Sign Up',
            requiresAuth: false
        }
    },
    {
        path: '/view/:id',
        name: 'viewer',
        component: () => import('./components/post/ViewPage.vue'),
        props: true,
        meta: {
            title: 'View Post',
            requiresAuth: false
        }
    },
    {
        path: '/tools',
        name: 'tools',
        component: () => import('./components/tools/ToolsPage.vue'),
        meta: {
            title: 'Tools',
            requiresAuth: false
        }
    },
    {
        path: '/tools/memorize',
        name: 'memorize',
        component: () => import('./components/tools/memorize/MemorizePage.vue'),
        meta: { title: '전기기능사 공식', requiresAuth: false }
    },
    {
        path: '/tools/memorize/study',
        name: 'memorize-study',
        component: () => import('./components/tools/memorize/MemorizeStudy.vue'),
        meta: { title: '공식 암기모드', requiresAuth: false }
    },
    {
        path: '/tools/calculator',
        name: 'calculator',
        component: () => import('./components/tools/calculator/CalculatorPage.vue'),
        meta: {
            title: 'Calculator',
            requiresAuth: false
        }
    },
    {
        path: '/tools/calculator/mortgage',
        name: 'mortgage-calculator',
        component: () => import('./components/tools/calculator/MortgageCalculator.vue'),
        meta: {
            title: 'Mortgage Calculator',
            requiresAuth: false
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('./components/profile/ProfilePage.vue'),
        meta: {
            title: 'Profile',
            requiresAuth: false
        }
    },
    {
        path: '/tools/productivity',
        name: 'productivity',
        component: () => import('./components/tools/productivity/ProductivityPage.vue'),
        meta: { title: 'Productivity', requiresAuth: false }
    },
    {
        path: '/tools/productivity/hierarchy',
        name: 'hierarchy',
        component: () => import('./components/tools/productivity/hierarchy/HierarchyPage.vue'),
        meta: { title: 'Hierarchy', requiresAuth: false }
    },
    {
        path: '/my-index',
        name: 'my-index',
        component: () => import('./components/my-index/MyIndexPage.vue'),
        meta: {
            title: 'My Index',
            requiresAuth: true
        }
    },
    {
        path: '/my-log',
        name: 'my-log',
        component: () => import('./components/my-log/MyLogPage.vue'),
        meta: {
            title: 'My Log',
            requiresAuth: false
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to, from, next) => {
    const isAuthenticated = !!await getCurrentUser();

    // Update document title based on route metadata
    if (to.meta.title) {
        document.title = `${to.meta.title} | Rocky's Blog`;
    } else {
        document.title = "Rocky's Blog";
    }

    // Auth guard: check if route requires authentication
    if (to.meta.requiresAuth && !isAuthenticated) {
        next('/sign-in'); // Redirect to sign-in page if not authenticated
    } else {
        next(); // Proceed to the route
    }
});

export default router;
